import React from "react";

import ButtonSecondary from "@app/components/1_elements/ButtonSecondary";
import { apiCall } from '@app/utils/apiCall';
import { useAuth } from '@app/contexts/AuthContext';
import { useCustomer, useCustomerDispatch, CUSTOMER_ACTIONS } from "@app/contexts/CustomerContext";
import { Download } from "lucide-react";
import DatePicker from "react-datepicker";
import Badge from "@app/components/1_elements/Badge";

import CalendarIcon from '@app/images/picto/calendar-week.svg';
import UploadButton from "@app/components/1_elements/UploadButton";

export default function SectionEnedis() {
    const auth = useAuth();
    const customer = useCustomer();
    const customerDispatch = useCustomerDispatch();

    function downloadDoc(event, type) {
        event.preventDefault();
        
        const formData = new FormData();

        formData.append("generated_document[customer_id]", customer.id);
        formData.append("generated_document[name]", type);
        formData.append("generated_document[doc_type]", type);

        apiCall ({
            method: "post",
            path: `/api/v1/generated_documents`,
            auth: auth,
            data: formData,
            onSuccess: (response) => {
                const file = response.data.generated_document.file;
                const link = document.createElement('a');

                link.href = file.url;
                link.download = file.filename;

                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        });  
    }

    function getCustomer() {
        apiCall ({
            method: "get",
            path: `/api/v1/customers/${customer.id}`,
            auth: auth,
            onSuccess: (response) => {
                const data = response.data.customer;
                
                customerDispatch({
                    type: CUSTOMER_ACTIONS.UPDATE_ALL,
                    payload: data
                });
            }
        });
    }    

    function updateDoc(doc, key, value, doc_type) {
        const method = doc?.id ? "patch" : "post";
        const path = doc?.id ? `/api/v1/generated_documents/${doc.id}` : `/api/v1/generated_documents`;      

        const formData = new FormData();

        if (doc?.id)
            formData.append("generated_document[id]", doc.id);

        formData.append("generated_document[customer_id]", customer.id);
        formData.append(`generated_document[${key}]`, value);
        formData.append(`generated_document[doc_type]`, doc_type);

        apiCall ({
            method: method,
            path: path,
            auth: auth,
            data: formData,
            onSuccess: (response) => {
                getCustomer();
            }
        });        
    }

    function displayDocStatus(document, doc_type) {        
        let status = "to_send";

        if (document) {
            status = document.status;
        }
        
        switch (status) {
            case "to_send": {
                return (<Badge label="A envoyer" classProp={`badge-${status}`} onClick={() => updateDoc(document, "status", "sent", doc_type) }/>)
            }
            case "signed": {
                return (<Badge label="Signé" classProp={`badge-${status}`} onClick={() => updateDoc(document, "status", "to_send", doc_type) }/>)
            }
            case "sent": {
                return (<Badge label="Envoyé" classProp={`badge-${status}`} onClick={() => updateDoc(document, "status", "signed", doc_type) }/>)
            }
            default: {
                return (<Badge label="À envoyer" classProp={`badge-${status}`} onClick={() => updateDoc(document, "status", "sent", doc_type) }/>)
            }
        }        
    }

    function displayDocSentAt(document, doc_type) {
        return (
            <DatePicker
                selected={document?.sent_at}
                className={"form-control "}
                onChange={(date) => updateDoc(document, "sent_at", date, doc_type)}
                locale="fr"
                dateFormat="dd/MM/yyyy"
                placeholderText="JJ/MM/AAAA"
                popperPlacement="bottom-start"
                showIcon
                toggleCalendarOnIconClick
                icon={<img src={CalendarIcon}/>}                
            /> 
        )  
    }    

    function displayUploadButton(document, doc_type) {        
        return (
            <UploadButton 
                defaultFile={document?.file}
                onChange={(file) => updateDoc(document, "file", file, doc_type)}
            />
        )
    }

    const enedisDoc = customer.generated_documents.find((doc) => doc.doc_type == "enedis_certificate_signed");
    const mandateDoc = customer.generated_documents.find((doc) => doc.doc_type == "electric_mandate_signed");

    return (
        <div>
            <div className="gray-line mb-4 mt-4"></div>
            <div className="row mb-4">
                <div className="col-6">
                    <strong>Suivi des documents</strong>
                </div>
            </div>
            <div className="row row-enedis-file">
                <div className="col-7">
                    <ButtonSecondary 
                        label="Autorisation ENEDIS" 
                        onClick={(event) => downloadDoc(event, "enedis_certificate")}
                        icon={<Download />}
                    />                                        
                </div>
                <div className="col-1">
                    {displayDocStatus(enedisDoc, "enedis_certificate_signed")}
                </div>
                <div className="col-2">
                    {displayDocSentAt(enedisDoc, "enedis_certificate_signed")}
                </div>
                <div className="col-2">
                    {displayUploadButton(enedisDoc, "enedis_certificate_signed")}
                </div>
            </div>
            <div className="row row-enedis-file">
                <div className="col-7">
                    <ButtonSecondary
                        label="Mandat Électrique" 
                        onClick={(event) => downloadDoc(event, "electric_mandate")}
                        icon={<Download />}
                    />
                </div>
                <div className="col-1">
                    {displayDocStatus(mandateDoc, "electric_mandate_signed")}
                </div>
                <div className="col-2">
                    {displayDocSentAt(mandateDoc, "electric_mandate_signed")}
                </div>
                <div className="col-2">
                    {displayUploadButton(mandateDoc, "electric_mandate_signed")}
                </div>                
            </div>
                        
        </div>
    )
}